import store from '@/store'
const generalLedger = () => import(/* webpackChunkName: "general-ledger" */ '@/views/ledger/general-ledger')
const Search = () => import(/* webpackChunkName: "general-ledger" */ '@/views/ledger/search.vue')
const reporta1 = () => import(/* webpackChunkName: "general-ledger" */  '@/views/ledger/general-ledger/reporta1.vue')
const reporta2 = () => import(/* webpackChunkName: "general-ledger" */  '@/views/ledger/general-ledger/reporta2.vue')
const reporta3 = () => import(/* webpackChunkName: "general-ledger" */  '@/views/ledger/general-ledger/reporta3.vue')
const reporta4 = () => import(/* webpackChunkName: "general-ledger" */  '@/views/ledger/general-ledger/reporta4.vue')
const reporta5 = () => import(/* webpackChunkName: "general-ledger" */  '@/views/ledger/general-ledger/reporta5.vue')
const reporta6 = () => import(/* webpackChunkName: "general-ledger" */  '@/views/ledger/general-ledger/reporta6.vue')
const reporta7 = () => import(/* webpackChunkName: "general-ledger" */  '@/views/ledger/general-ledger/reporta7.vue')
const reporta8 = () => import(/* webpackChunkName: "general-ledger" */  '@/views/ledger/general-ledger/reporta8.vue')
const reporta9 = () => import(/* webpackChunkName: "general-ledger" */  '@/views/ledger/general-ledger/reporta9.vue')

const generalLedger_Leading = {
    path: 'general-ledger', 
    name: 'general-ledger',
    component: generalLedger,
    meta: { title: '总帐' },
  redirect: '/main/:GD/general-ledger/search',
    beforeEnter: (to, from, next) => {
      if (store.getters.getpermission.report[0] != '1') return next({ name: 'no-permission', params: to.params})
      next()
    },
    children: [
      {
        path: 'search',
        component: Search,
        name: 'generalLedgerSearch',
        meta: { title: '总帐搜寻', name: 'generalLedger' }
      },
      {
        path: 'reporta1',
        name: 'general-ledger-reporta1',
        component: reporta1,
        meta: { title: 'reporta1' }
      },
      {
        path: 'reporta2',
        name: 'general-ledger-reporta2',
        component: reporta2,
        meta: { title: 'reporta2' }
      },
      {
        path: 'reporta3',
        name: 'general-ledger-reporta3',
        component: reporta3,
        meta: { title: 'reporta3' }
      },
      {
        path: 'reporta4',
        name: 'general-ledger-reporta4',
        component: reporta4,
        meta: { title: 'reporta4' }
      },
      {
        path: 'reporta5',
        name: 'general-ledger-reporta5',
        component: reporta5,
        meta: { title: 'reporta5' }
      },
      {
        path: 'reporta6',
        name: 'general-ledger-reporta6',
        component: reporta6,
        meta: { title: 'reporta6' }
      },
      {
        path: 'reporta7',
        name: 'general-ledger-reporta7',
        component: reporta7,
        meta: { title: 'reporta7' }
      },
      {
        path: 'reporta8',
        name: 'general-ledger-reporta8',
        component: reporta8,
        meta: { title: 'reporta8' }
      },
      {
        path: 'reporta9',
        name: 'general-ledger-reporta9',
        component: reporta9,
        meta: { title: 'reporta9' }
      },
    ]
}

export default generalLedger_Leading